import { useQuery } from '@tanstack/react-query';
import useFetchedSinceOpened from 'src/common/hooks/useFetchedSinceOpened';
import { notifyAndLogError } from 'src/UI/common/ui-helpers';
import type { SiestaSkill } from '../types';

/** `onLoadFailed` runs when the skill cannot be loaded on opening, after the user has been told. */
export default function useTenantSkill(skillId: string | null, onLoadFailed?: () => void) {
  const query = useQuery<SiestaSkill>({
    queryKey: ['tenant', 'custom-skills', skillId],
    enabled: skillId !== null,
  });
  // A skill can change outside the editor (an approved Siesta proposal, the library, another tab),
  // and the editor takes its values once, so it opens only on a copy fetched since it was opened.
  const freshSkill = useFetchedSinceOpened(query, skillId, error => {
    notifyAndLogError("Couldn't load this skill", 'Please try again.', error);
    onLoadFailed?.();
  });
  return { ...query, freshSkill };
}
